import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { Subscription } from "../types/subscription";

export const startSubscription = async (config: {
  "page-id": string;
  "app-id": string;
}): Promise<Subscription> => {
  const ednString = toEDNStringFromSimpleObject(config as any, { keysAs: "string" });
  const query = `
(datastore Qo.Public.OqlApi.Page.Bl.Sub "omega/query-omega/public/oql-api/page/block/subscription")
(Qo.Public.OqlApi.Page.Bl.Sub/start ${ednString} Result)
(return [Result])
  `;
  return queryOmegaSingleResult(query);
};

export const stopSubscription = async (config: {
  "page-id": string;
  "app-id": string;
}): Promise<Subscription> => {
  const ednString = toEDNStringFromSimpleObject(config as any, { keysAs: "string" });
  const query = `
(datastore Qo.Public.OqlApi.Page.Bl.Sub "omega/query-omega/public/oql-api/page/block/subscription")
(Qo.Public.OqlApi.Page.Bl.Sub/stop ${ednString} Result)
(return [Result])
  `;
  return queryOmegaSingleResult(query);
};
